import { Branded }		from "ts-base/branded";
import { Strings }		from "ts-base/strings";
import { Equal }		from "ts-base/equal";
import { Comparator }	from "ts-base/comparator";
import { Semigroup }	from "ts-base/semigroup";
import { Textual }		from "ts-base/textual/textual";

/** non-empty string */
export type Nes	= Branded<string, "Nes">;

export namespace Nes {
	export const name		= "Nes";

	export const brand		= Branded.brand<Nes>;
	export const is			= (it:string):it is Nes	=> it !== "";

	export const fromString	= (it:string):Nes|null	=> is(it) ? brand(it) : null;
	export const toString	= (it:Nes):string		=> it;

	export const concat		= (a:Nes, b:Nes):Nes	=> brand(a + b);

	export const equal:Equal<Nes>			= Strings.equal;
	export const compare:Comparator<Nes>	= Strings.compare;
	export const joined:Semigroup<Nes>		= { concat: concat	};
}

// just for type checking
Textual.typed(Nes);
